export enum SubmissionSubStatusIdEnum {
  Ready = 1,
  PendingDocuments = 2,
  Processing = 3,
  MemberActionRequired = 4,
  EmployerActionRequired = 5,
  ReadyForApproval = 6,
  Approved = 7,
  AutoApproved = 8,
  Rejected = 9,
  Cancelled = 10
}
